import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService, NavigationService } from '@core/services';
import { environment } from '@environment';
import { EDeveloperProfile } from '@environment.namespace';

export const publicRoutesGuard: CanActivateFn = () => {
  const navigationService = inject(NavigationService);
  const authService = inject(AuthService);

  console.log('publicRoutesGuard');
  if (environment.devProfile === EDeveloperProfile.IANTROPOV_IIS) {
    //  return true;
  }

  if (authService.isAuthenticated()) {
    navigationService.navigateToReportAbonaments();
    return false;
  }
  return true;
};
